import type { SubscriptionType, UserType } from '@kanbu/schema';
import type { StateCreator } from 'zustand';

import { queryClient } from '@/services/queryClient';

export type UserSlice = {
  organizationTransitioning: boolean;
  jwt: string | null;
  user: null | UserType;
  activeSubscription: ActiveSubscriptionState | null;
  setJwt: (jwt: string | null) => void;
  setUser: (user: UserType | null) => void;
  setActiveSubscription: (subscription: ActiveSubscriptionState | null) => void;
  currentOrganizationId: string | null;
  setCurrentOrganizationId: (currentOrganizationId: string | null) => void;
  hasFeature: (feature: string) => boolean;
  clearActiveSubscription: () => void;
  logout: () => void;
};

export type ActiveSubscriptionState = SubscriptionType & {
  currentDocumentCount: number;
  features: string[];
};

export const userSlice: StateCreator<UserSlice> = (set, get) => ({
  organizationTransitioning: false,
  jwt: null,
  user: null,
  activeSubscription: null,
  setJwt: jwt => set({ jwt }),
  setUser: user => set({ user }),
  setActiveSubscription: activeSubscription => set({ activeSubscription }),
  currentOrganizationId: null,
  setCurrentOrganizationId: currentOrganizationId =>
    set({ currentOrganizationId }),
  hasFeature: feature =>
    get().activeSubscription?.features.includes(feature.trim()) ?? false,
  clearActiveSubscription: () => set({ activeSubscription: null }),
  logout: () => {
    // Clear the query cache
    queryClient.clear();

    // Clear the user state
    set({
      jwt: null,
      user: null,
      activeSubscription: null,
      currentOrganizationId: null,
    });
  },
});
